import React from 'react';
import PropTypes from 'prop-types';
import { PropTypesRepo } from '../functions/_propTypes';
import { withTheme } from '../core/theming';

import MonochromeHeader from './MonochromeHeader';
import MonochromeMenu from './MonochromeMenu';
import OnpointHeader from './OnpointHeader';
import OnpointMenu from './OnpointMenu';
import Content from './Content';
import Div from './Div';

const Application = ({
  minH,
  minW,
  header: { children: headerChildren, ...headerRest },
  content: { children: contentChildren, ...contentRest },
  menu,
  variant,
}) => (
  <Div minH={minH} h="100%" minW={minW} w="100%" pos="relative">
    {variant === 'monochrome' && (
      <>
        <MonochromeHeader {...headerRest}>{headerChildren}</MonochromeHeader>
        <MonochromeMenu {...menu} />
      </>
    )}
    {variant === 'onpoint' && (
      <>
        <OnpointHeader {...headerRest}>{headerChildren}</OnpointHeader>
        <OnpointMenu {...menu} />
      </>
    )}
    <Content {...contentRest}>{contentChildren}</Content>
  </Div>
);

Application.propTypes = {
  header: PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  }),
  content: PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    contentStyle: PropTypes.shape({}),
  }),
  menu: PropTypes.shape({}),
  minH: PropTypesRepo.minH,
  minW: PropTypesRepo.minW,
  variant: PropTypes.oneOf(['onpoint', 'monochrome']),
};

Application.defaultProps = {
  header: {
    children: null,
  },
  content: {
    children: null,
    contentStyle: {},
  },
  menu: {},
  minH: '100vh',
  minW: '100vw',
  variant: 'onpoint',
};

export default withTheme(Application);
